<div class="login-page" [class.compact-login-page]="isAccessDenied">
  <div class="login-brand-panel" *ngIf="!isAccessDenied">
    <img [src]="imgLogo" alt="Explorandes" class="brand-logo" />
    <div class="brand-copy">
      <span class="brand-eyebrow">Operations</span>
      <h1>Operaciones</h1>
    </div>
  </div>

  <div class="login-card-panel">
    <mat-card class="login-card">
      <img [src]="imgLogoPrincipal" alt="Explorandes" class="login-logo" />
      <mat-card-content>
        <div class="hosted-login-state">
          <mat-icon class="login-state-icon">
            {{ loading ? 'sync' : statusTitle === 'Acceso denegado' ? 'block' : 'lock' }}
          </mat-icon>
          <h2>{{ statusTitle }}</h2>
          <p>{{ statusMessage }}</p>
          <small class="status-detail" *ngIf="statusDetail">{{ statusDetail }}</small>

          <button
            *ngIf="showLoginButton"
            mat-raised-button
            class="buttonPrimary"
            type="button"
            (click)="loginWithCognito()"
          >
            {{ actionLabel }}
          </button>
        </div>
      </mat-card-content>
    </mat-card>
  </div>
</div>
